import { motion } from "framer-motion";
import {
    ShieldCheck,
    CalendarCheck,
    Lightning,
    Clock,
    HandHeart,
    HouseLine,
    MapPinArea,
} from "@phosphor-icons/react";

const reasons = [
    { icon: ShieldCheck, title: "Certifié RGE", desc: "Reconnu Garant de l'Environnement." },
    { icon: CalendarCheck, title: "Rendez-vous rapide", desc: "Disponibilités sous quelques jours." },
    { icon: Lightning, title: "Intervention rapide", desc: "Visite sur site dans les meilleurs délais." },
    { icon: Clock, title: "Rapport sous 24-48h", desc: "Document complet livré express." },
    { icon: HandHeart, title: "Accompagnement", desc: "Conseils personnalisés à chaque étape." },
    { icon: HouseLine, title: "Maison & Copropriété", desc: "Expertise tout type de bien." },
    { icon: MapPinArea, title: "3 départements", desc: "Île-de-France · Oise · Aisne." },
];

export default function WhyLumos() {
    return (
        <section data-testid="why-section" className="relative py-24 lg:py-28 bg-lumos-bg overflow-hidden">
            <div className="absolute inset-0 bg-grid opacity-50" />
            <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-lumos-blue/6 blur-3xl" />

            <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
                    <div>
                        <span className="eyebrow">Pourquoi LUMOS</span>
                        <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-lumos-ink leading-[1.05]">
                            La confiance,<br className="hidden sm:block" />
                            <span className="font-serif-display text-lumos-blue">en sept points clés.</span>
                        </h2>
                    </div>
                    <p className="text-lumos-muted lg:max-w-md">
                        Un savoir-faire technique, une exécution rapide, un accompagnement humain.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {reasons.map((r, i) => {
                        const Icon = r.icon;
                        const isHighlight = i === 0; // RGE highlight
                        return (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 22 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 0.5, delay: i * 0.05 }}
                                data-testid={`why-card-${i}`}
                                className={`group relative rounded-2xl p-6 border transition-all duration-500 ${
                                    isHighlight
                                        ? "bg-lumos-midnight text-white border-lumos-midnight col-span-1 sm:col-span-2 lg:col-span-2 lg:row-span-1 overflow-hidden"
                                        : "bg-white border-lumos-border card-lift"
                                }`}
                            >
                                {isHighlight && (
                                    <>
                                        <div className="absolute inset-0 bg-grid-dark opacity-40" />
                                        <div className="absolute -bottom-16 -right-10 w-60 h-60 rounded-full bg-lumos-blue/30 blur-3xl" />
                                    </>
                                )}
                                <div className={`relative w-12 h-12 rounded-xl grid place-items-center mb-4 transition-transform duration-500 group-hover:scale-110 ${
                                    isHighlight ? "bg-lumos-green/25 text-lumos-green" : "bg-lumos-blue/10 text-lumos-blue"
                                }`}>
                                    <Icon size={26} weight={isHighlight ? "fill" : "duotone"} />
                                </div>
                                <h3 className={`relative font-display font-bold text-lg mb-1.5 ${isHighlight ? "text-white text-2xl lg:text-3xl" : "text-lumos-ink"}`}>
                                    {r.title}
                                </h3>
                                <p className={`relative text-sm ${isHighlight ? "text-white/75 text-base max-w-md" : "text-lumos-muted"}`}>
                                    {r.desc}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
